import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Appointment } from '@sc/data-access-models';
import { mergeArrays } from '@sc/utils';
import {
  AppointmentsAddedAction,
  AppointmentsClearedAction,
  AppointmentsRemoveAction,
} from './appointments.actions';

@State<Appointment[]>({
  name: 'appointments',
  defaults: [],
})
@Injectable()
export class AppointmentsState {
  @Action(AppointmentsAddedAction)
  add(
    ctx: StateContext<Appointment[]>,
    { appointments, merge }: AppointmentsAddedAction
  ): void {
    const state = ctx.getState();
    let newState = appointments.slice();
    if (merge) {
      newState = mergeArrays(
        newState,
        state,
        (appointment1, appointment2) =>
          appointment1.id === appointment2.id &&
          appointment1.fitterId === appointment2.fitterId &&
          appointment1.outsideIntervention === appointment2.outsideIntervention
      );
    } else {
      newState.push(...state);
    }
    ctx.setState(newState);
  }

  @Action(AppointmentsClearedAction)
  clear(ctx: StateContext<Appointment[]>): void {
    ctx.setState([]);
  }

  @Action(AppointmentsRemoveAction)
  remove(
    ctx: StateContext<Appointment[]>,
    { appointmentsToRemove }: AppointmentsRemoveAction
  ): void {
    ctx.setState(
      ctx.getState().filter((a) => !appointmentsToRemove.includes(a.id))
    );
  }
}
